import React, { useState } from 'react'
import { IAddAttachmentsRPDropdownOption } from '../../interfaces/IAddAttachmentsRPDropdownOption'
import { Dialog } from 'primereact/dialog'
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown'
import classes from './AddAttachmentsRPBulkEditDialog.module.scss'
import RequiredAsterisk from '../required-asterisk/RequiredAsterisk'

interface AddAttachmentsRPBulkEditDialogProps {
  dropdownOption: IAddAttachmentsRPDropdownOption[]
  title: string
  visible: boolean

  subHeader?: string

  onConfirm: (updatedValue: string) => void
  onCancel: () => void
}

const AddAttachmentsRPBulkEditDialog = (props: AddAttachmentsRPBulkEditDialogProps) => {
  const [selectedValue, setSelectedValue] = useState<string>('')

  const onDropdownChange = async (e: DropdownChangeParams) => {
    setSelectedValue(e.value)
  }

  const onCancel = () => {
    setSelectedValue('')
    props.onCancel()
  }

  const onConfirm = () => {
    props.onConfirm(selectedValue)
    setSelectedValue('')
  }

  const InlineFooter = () => {
    return (
      <>
        <hr className="modal-footer-hr" />
        <div className={`${classes['dialog-footer']} ${classes['center-items']}`}>
          <button
            className={`ul-button -medium ${classes['dialog-cancel-btn']}`}
            onClick={onCancel}
          >
            CANCEL
          </button>
          <button
            className={`ul-button -medium ${classes['dialog-save-btn']} confirm-button-target`}
            disabled={!selectedValue}
            onClick={onConfirm}
          >
            SAVE
          </button>
        </div>
      </>
    )
  }
  const InlineBody = () => {
    return (
      <>
        <div>
          {props.title}
          <RequiredAsterisk style={{ paddingLeft: '0.3rem' }} />
        </div>
        <div>
          <Dropdown
            value={selectedValue}
            options={props.dropdownOption}
            onChange={onDropdownChange}
            className={classes['custom-dropdown']}
            style={{
              width: '100%',
              marginTop: '5px',
              marginBottom: '5px',
            }}
            placeholder="Select"
            optionDisabled="disabled"
          />
        </div>
      </>
    )
  }

  const InlineTitle = () => {
    return (
      <>
        <div>Select {props.title}</div>
        {props.subHeader && (
          <div className={classes['add-attachments-rp-bulk-edit-subheader']}>
            ({props.subHeader})
          </div>
        )}
      </>
    )
  }
  return (
    <>
      <Dialog
        className={classes['custom-dialog']}
        header={<InlineTitle />}
        footer={<InlineFooter />}
        draggable={false}
        visible={props.visible}
        onHide={onCancel}
        style={{ width: '30vw' }}
      >
        <hr className="modal-header-hr" />
        <div className={classes['body-container']}>
          <div>{<InlineBody />}</div>
        </div>
      </Dialog>
    </>
  )
}

export default AddAttachmentsRPBulkEditDialog
